export default __webpack_public_path__ + "23b8eb1a8d217fea194c79dee4ff34d8.jpg";